import { useAuth } from '@frontegg/react';
import { isInSaaSMode } from '../utils/common';
import useSelectedEnv from './useSelectedEnv';

const useGraphqlRequestParams = ({ envId }: { envId?: string }) => {
  const authHook = isInSaaSMode() ? useAuth : null;

  const authData = authHook?.();
  const accessToken = authData?.user?.accessToken;

  const environmentIdParam = useSelectedEnv();

  const environmentId = envId || environmentIdParam;

  const gqlEndpoint = `${window.VITE_API_BASE_URL}/${environmentId}/graphql`;

  return {
    accessToken,
    environmentId,
    gqlEndpoint,
  };
};

export default useGraphqlRequestParams;
